// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_cs-3";
export var flatBottomCorners = "_cs-5";
export var productImage = "_cs-0";
export var quantityContainer = "_cs-2";
export var quantityHeader = "_cs-6";
export var tooltip = "_cs-1";
export var wrapAndEllipsesOverflow = "_cs-4";